import { v4 as uuidv4 } from 'uuid';
import MandirDonationImg from '../images/ram_madir_donation_project-1.png';
import IndoreMallImg from '../images/indore_mall_project-2.png';
import CovidTrackImg from '../images/covid-19_tracking-dashboard_project-3.png';
import AddListCollImg from '../images/add_list_collection_project-4.png';
import TopCollImg from '../images/top_collage_searching_project-5.png';
import SubmitFormImg from '../images/best_submit_form_project-6.png';
import CounterRateImg from '../images/counter_reading_project-7.png';
import GoogleKeepImg from '../images/google_keep_project_8.png';
import DashboardCovidImg from '../images/dashboard_19_covid_project-9.png';
import KisanIndustriesImg from '../images/kisan_agro_industries-project-10.png';
import TextUtilsImg from '../images/textutils_project-11.png';
import VarlyQnterviewImg from '../images/varlyq_interview_question-1_project-12.png';
import Update from '../images/update.jpg';
// import ProjectImg from '../images/projectImg.png';
// import UTrackerImg from '../images/utracker.jpg';
// import GreenCtgImg from '../images/greenctg.jpg';
// import CoinTrackerImg from '../images/cointracker.jpg';
// import CavinImg from '../images/cavinimg.jpg';

const projects = [
  {
    id: uuidv4(),
    name: 'Ram Mandir Donation Website',
    desc:
      'Online Donation facility has been made in this website for the general public to donate at religious places.',
    img: MandirDonationImg,
  },
  {
    id: uuidv4(),
    name: 'Indore Shopping Mall Website',
    desc:
      'Shop easily here on this website by visiting our online Indore Shopping Mall Website.',
    img: IndoreMallImg,
  },
  {
    id: uuidv4(),
    name: 'Covid-19 Tracking Website',
    desc:
      'In this website we can see all the cases related to Covid-19 spread across the world.',
    img: CovidTrackImg,
  },
  {
    id: uuidv4(),
    name: 'Add Friends List Application',
    desc:
      'Inside this Application we can add any type of data and make a list.',
    img: AddListCollImg,
  },
  {
    id: uuidv4(),
    name: 'Top Collages Searching App...',
    desc:
      'Through this Application, we can search the colleges of Madhya Pradesh and take admission by visiting them.',
    img: TopCollImg,
  },
  {
    id: uuidv4(),
    name: 'User Submit Form Page',
    desc:
      'In this Submit Form, we have seen how we can store user data in some way and show it on desktop.',
    img: SubmitFormImg,
  },
  {
    id: uuidv4(),
    name: 'Counter Rating Application',
    desc:
      'With the help of Counter Rating Application, we can increase or decrease any number and we can check it till infinity.',
    img: CounterRateImg,
  },
  {
    id: uuidv4(),
    name: 'Google Keep Application',
    desc:
      'With the help of Google Keep, add to notes, checks off tasks from your to-do list, and more. with Google Keep, you can create, share, and collaborate with people on notes and lists, keep sync across all your devices s your notes and lists go with you wherever you go.',
    img: GoogleKeepImg,
  },
  {
    id: uuidv4(),
    name: 'Dashboard API Covid-19 Website',
    desc:
      'In this website we can see all the cases related to Covid-19 spread across the world.',
    img: DashboardCovidImg,
  },
  {
    id: uuidv4(),
    name: 'Kisan Agro Industries web',
    desc:
      'Farmers Agro Industries Farmers can buy the things used in their Agriculture from this company',
    img: KisanIndustriesImg,
  },
  {
    id: uuidv4(),
    name: 'TextUtils Application',
    desc:
      'In TextUtils Application, we can take whatever text we write in the text box by converting it to any format.',
    img: TextUtilsImg,
  },
  {
    id: uuidv4(),
    name: 'interview Storing Data App',
    desc:
      'You will be required to create a react web app using react, redux (for storing data), material-UI (for designing purposes), and Axios (for fetching data)..',
    img: VarlyQnterviewImg,
  },
  {
    id: uuidv4(),
    name: 'New Updated Projects',
    desc: '-----------New Updating------------',
    img: Update,
  },
  // {
  //   id: uuidv4(),
  //   name: 'U Tracker',
  //   desc:
  //     'An application to track your all data from one place. I developed the website and the mobile app',
  //   img: UTrackerImg,
  // },
  // {
  //   id: uuidv4(),
  //   name: 'Green CTG',
  //   desc:
  //     'An app to help people to get an overview of how they can make the city beautiful.',
  //   img: GreenCtgImg,
  // },
  // {
  //   id: uuidv4(),
  //   name: 'Coin Tracker',
  //   desc:
  //     'Using this app you can track any e coin. Also you will get a good advise about investment form the professional',
  //   img: CoinTrackerImg,
  // },
  // {
  //   id: uuidv4(),
  //   name: "Cavin's Portfolio",
  //   desc:
  //     'A portfolio for Cavin jr. A artist from New york city. The portfolio is made using ReactJs and GatsbyJs.',
  //   img: CavinImg,
  // },
  // {
  //   id: uuidv4(),
  //   name: 'Tracking Soft',
  //   desc:
  //     'A tracking website that will show the performance of the website. Also you will get some useful advice to improve the performance.',
  //   img: ProjectImg,
  // },
];

export default projects;
